import { render, staticRenderFns } from "./scheme.vue?vue&type=template&id=1adc04dc"
import script from "./scheme.vue?vue&type=script&lang=js"
export * from "./scheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports